type SidebarProgressBarProps = {
  readonly stepNumber: number;
  readonly totalSteps: number;
};

export default function SidebarProgressBar({
  stepNumber,
  totalSteps
}: SidebarProgressBarProps) {
  const percent =
    totalSteps > 0 ? Math.min(stepNumber / totalSteps, 1) * 100 : 0;

  return (
    <div className='flex shrink-0 items-center gap-3'>
      <span className='whitespace-nowrap text-sm font-semibold text-gray-700'>
        Step {stepNumber} of {totalSteps}
      </span>
      <div
        className='h-2 flex-1 overflow-hidden rounded-full bg-gray-200'
        role='progressbar'
        aria-valuenow={stepNumber}
        aria-valuemin={0}
        aria-valuemax={totalSteps}
      >
        <div
          className='h-full rounded-full bg-green-600 transition-all duration-300'
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
